import { apiClient } from '../api/client.js';
import {
  AuthResolveResponseSchema,
  type AuthResolveResponse,
} from '../api/schemas/index.js';

/**
 * Calls `POST /api/auth/resolve` — the email-first login-method resolution
 * endpoint (unified-auth Phase 3, backend). Unauthenticated and
 * existence-safe: the response is a two-valued `{ method: 'federate' | 'local' }`
 * verdict derived from the email's domain only. It never indicates whether an
 * account exists for the submitted address (unified-auth-architecture.md
 * critique C2).
 *
 * Not a stateful React hook (no internal state is needed) — the name mirrors
 * the roadmap's provisional file so future contributors find it where the
 * plan says it lives.
 */
export async function resolveAuthMethod(
  email: string
): Promise<AuthResolveResponse> {
  const normalizedEmail = email.trim().toLowerCase();
  return apiClient.post(
    '/api/auth/resolve',
    { email: normalizedEmail },
    { schema: AuthResolveResponseSchema }
  );
}

export default resolveAuthMethod;
